var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"threejsContainer"},[_c('div',{staticClass:"containerTitle"},[_vm._v("1-9.动态拉伸")]),_c('div',{ref:"container",staticClass:"containerBody"})])
}
var staticRenderFns = []

export { render, staticRenderFns }